var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpushsubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#FFF1EF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_18264)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_18264",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 12.5H32.6719V32.5H12.6719V12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_18264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1719 21H30.1719V19C30.1719 18.725 29.9469 18.5 29.6719 18.5H28.6719C28.3969 18.5 28.1719 18.725 28.1719 19V21H26.1719C25.8969 21 25.6719 21.225 25.6719 21.5V22.5C25.6719 22.775 25.8969 23 26.1719 23H28.1719V25C28.1719 25.275 28.3969 25.5 28.6719 25.5H29.6719C29.9469 25.5 30.1719 25.275 30.1719 25V23H32.1719C32.4469 23 32.6719 22.775 32.6719 22.5V21.5C32.6719 21.225 32.4469 21 32.1719 21ZM19.6719 22.5C21.8813 22.5 23.6719 20.7094 23.6719 18.5C23.6719 16.2906 21.8813 14.5 19.6719 14.5C17.4625 14.5 15.6719 16.2906 15.6719 18.5C15.6719 20.7094 17.4625 22.5 19.6719 22.5ZM22.4719 23.5H21.95C21.2562 23.8188 20.4844 24 19.6719 24C18.8594 24 18.0906 23.8188 17.3938 23.5H16.8719C14.5531 23.5 12.6719 25.3813 12.6719 27.7V29C12.6719 29.8281 13.3438 30.5 14.1719 30.5H25.1719C26 30.5 26.6719 29.8281 26.6719 29V27.7C26.6719 25.3813 24.7906 23.5 22.4719 23.5Z",
    fill: "#FF754C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_18264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.6719 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpushsubscription);
export default __webpack_public_path__ + "static/media/fullpushsubscription.07a071b827f0ab4113ba5d44acf67422.svg";
export { ForwardRef as ReactComponent };